import { useState } from "react";
import {
  Select,
  MenuItem,
  Dialog,
  DialogContent,
  DialogTitle,
  Box,
  IconButton,
} from "@mui/material";
import { toast } from "react-toastify";
import ButtonLoading from "../../../components/ButtonLoading";
import SubTitle from "../../../components/SubTitle";

import DialogConfirm from "../../../components/DialogConfirm";
import { createUpdateTestCase, deleteTestCase } from "../../../api/projects";
import { USER_DATA } from "../../../utils/constants";

import DownIcon from "@mui/icons-material/ArrowDropDown";
import UpIcon from "@mui/icons-material/ArrowDropUp";
import LineIcon from "@mui/icons-material/UnfoldMoreOutlined";

import ProjectIcon from "@mui/icons-material/ArrowRight";
import CloseIcon from "@mui/icons-material/Close";

import { CSSProperties } from "react";
import { SuiteTypes } from "../../../interfaces/SuiteTypes";
import Row from "../../../components/layout/Row";
import Input from "../../../components/Input";
import Title from "../../../components/Title";
import { colors } from "../../../assets/colors";
import Divider from "../../../components/Divider";
import { mountHistory } from "../../../utils/history";
import { createHistory } from "../../../api/history";
import { ActionTypeEnum } from "../../../interfaces/HistoryTypes";

interface Props {
  id?: any;
  open: boolean;
  close: (reload?: boolean) => void;
  currentProject: any;
  testCaseSelected: any;
  suites: any;
  reload?: () => void;
}

function DialogTestCase(props: Props) {
  const [open, setOpen] = useState(true);

  const [projectTitle, setProjectTitle] = useState(
    `${props.currentProject.project_id} - ${props.currentProject.title}`
  );
  const [id, setId] = useState(
    props.testCaseSelected ? props.testCaseSelected["id"] : null
  );

  const [title, setTitle] = useState(
    props.testCaseSelected ? props.testCaseSelected["title"] : null
  );
  const [description, setDesciption] = useState(
    props.testCaseSelected ? props.testCaseSelected["description"] : ""
  );
  const [preconditions, setPreconditions] = useState(
    props.testCaseSelected ? props.testCaseSelected["pre_conditions"] : ""
  );
  const [result, setResult] = useState(
    props.testCaseSelected ? props.testCaseSelected["expected_result"] : ""
  );
  const [steps, setSteps] = useState(
    props.testCaseSelected ? props.testCaseSelected["steps"] : ""
  );
  const [othersInformations, setOthersInformations] = useState(
    props.testCaseSelected ? props.testCaseSelected["others_info"] : ""
  );
  const [priority, setPriority] = useState(
    props.testCaseSelected ? props.testCaseSelected["priority"] : ""
  );
  const [type, setType] = useState(
    props.testCaseSelected ? props.testCaseSelected["type"] : ""
  );

  const [suites, setSuites] = useState(props.suites);
  const [selectedSuite, setSelectedSuite] = useState(
    props.testCaseSelected ? props.testCaseSelected["suite"] : ""
  );

  const [loading, setLoading] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  const toggleDrawer = (open: boolean) => (event: any) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setOpen(open);
    props.close();
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();

    const data = [
      {
        title,
        id: new Date().getTime(),
        project_id: props.currentProject.project_id,
        priority,
        type,
        steps,
        others_info: othersInformations,
        suite: selectedSuite,
        description,
        pre_conditions: preconditions,
        expected_result: result,
      },
    ];

    const userData = localStorage.getItem(USER_DATA);
    const user_uuid = userData ? JSON.parse(userData).uid : "";
    const project_id = props.currentProject.project_id;

    setLoading(true);
    createUpdateTestCase(user_uuid, project_id, selectedSuite, data, id)
      .then(() => {
        toast.success("Casos de teste adicionado com sucesso");
        // createHistory(
        //   mountHistory(
        //     project_id,
        //     id ? ActionTypeEnum.UPDATE : ActionTypeEnum.CREATE,
        //     "Caso de Testes: de " + id
        //       ? props.testCaseSelected["title"]
        //       : "-" + " para " + title
        //   )
        // );
        props.close(true);
      })
      .catch((e) => {
        console.log(e);
        toast.error("Ocorreu um problema, tente mais tarde!!!!");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const deleteItem = (responseOk: boolean) => {
    setOpenDelete(false);
    if (!responseOk) {
      return;
    }

    const project_id = props.currentProject.project_id;

    setLoading(true);
    deleteTestCase(project_id, selectedSuite, id)
      .then(() => {
        toast.success("Caso de Teste excluído com sucesso");
        createHistory(
          mountHistory(
            project_id,
            ActionTypeEnum.DELETE,
            "Caso de Testes: " + title
          )
        );
        props.close(true);
      })
      .catch((e) => {
        toast.error("Ocorreu um problema, tente mais tarde!");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleClose = () => {
    props.close();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullScreen
      style={styles.container}
    >
      <DialogTitle>
        <Row space>
          Caso de Teste
          <IconButton onClick={handleClose}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </Row>
      </DialogTitle>

      <Divider />

      <DialogContent>
        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <Box>
            <Row>
              <Title
                text={`${projectTitle}`}
                textStyle={{ opacity: 0.5, marginBottom: 24 }}
              />
            </Row>

            <Row>
              <ProjectIcon />
              <SubTitle text={"Resumo"} style={{ marginLeft: 1 }} />
            </Row>

            <Input
              title="Título"
              placeholder="Título do caso de teste"
              required
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />

            <Input
              title="Descrição"
              placeholder="Descrição do caso de teste"
              rows={3}
              multiline
              value={description}
              required
              onChange={(e) => setDesciption(e.target.value)}
            />
          </Box>

          <div
            style={{
              backgroundColor: "#F3F3F3B3",
              marginTop: 24,
              paddingLeft: 20,
              paddingRight: 20,
              paddingTop: 10,
              paddingBottom: 10,
              marginBottom: 20,
            }}
          >
            <Row>
              <ProjectIcon />
              <SubTitle
                text={"Informações do Caso de Teste"}
                style={{ marginLeft: 1 }}
              />
            </Row>

            <Input
              title="Pré condições"
              placeholder="Pré condições do caso de teste"
              rows={4}
              multiline
              value={preconditions}
              required
              onChange={(e) => setPreconditions(e.target.value)}
            />

            <Input
              title="Passo a Passo"
              placeholder="Steps do caso de teste"
              rows={4}
              multiline
              value={steps}
              required
              onChange={(e) => setSteps(e.target.value)}
            />

            <Input
              title="Outras Informações"
              placeholder="Outras informações do caso de teste"
              rows={4}
              multiline
              value={othersInformations}
              onChange={(e) => setOthersInformations(e.target.value)}
            />

            <Input
              title="Resultado Esperado"
              placeholder="Resultado esperado do caso de teste"
              rows={2}
              multiline
              required
              value={result}
              onChange={(e) => setResult(e.target.value)}
            />
          </div>

          <Row>
            <ProjectIcon />
            <SubTitle text={"Outras informações"} style={{ marginLeft: 1 }} />
          </Row>

          <Row space style={{ gap: 16 }}>
            <Select
              sx={{ width: "100%" }}
              value={priority}
              onChange={(type) => setPriority(type.target.value)}
              displayEmpty
              required
              inputProps={{
                sx: {
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "row",
                },
              }}
            >
              <MenuItem value="">
                <em>Prioridade</em>
              </MenuItem>
              <MenuItem value={"LOW"}>
                <UpIcon sx={{ color: colors.status.green }} /> Baixa
              </MenuItem>
              <MenuItem value={"MEDIUM"}>
                <LineIcon sx={{ color: colors.status.yellow }} /> Media
              </MenuItem>
              <MenuItem value={"HIGH"}>
                <DownIcon sx={{ color: colors.status.red }} /> Alta
              </MenuItem>
            </Select>

            <Select
              sx={{
                width: "100%",
              }}
              value={type}
              onChange={(t) => setType(t.target.value)}
              required
              displayEmpty
              inputProps={{
                sx: {
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "row",
                  gap: 1,
                },
              }}
            >
              <MenuItem value="">
                <em>Tipo</em>
              </MenuItem>
              <MenuItem
                value={"MANUAL"}
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "row",
                  gap: 8,
                }}
              >
                <i className="material-icons">back_hand </i>
                <span>Manual</span>
              </MenuItem>
              <MenuItem
                value={"AUTOMATED"}
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "row",
                  gap: 8,
                }}
              >
                <i className="material-icons">code</i>
                <span>Automatizado</span>
              </MenuItem>
              <MenuItem
                value={"INTEGRATION"}
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "row",
                  gap: 8,
                }}
              >
                <i className="material-icons">settings</i>
                <span>Integração</span>
              </MenuItem>
            </Select>

            <Select
              sx={{ width: "100%" }}
              value={selectedSuite}
              onChange={(type) => setSelectedSuite(type.target.value)}
              displayEmpty
              required
              disabled={id ? true : false}
            >
              <MenuItem value="">
                <em>Suite</em>
              </MenuItem>
              {suites.map((suite: SuiteTypes) => (
                <MenuItem value={suite.id}>{suite.title}</MenuItem>
              ))}
            </Select>
          </Row>

          <Row style={styles.buttonContainer}>
            <ButtonLoading label="Salvar Caso de Teste" loading={loading} />

            {id ? (
              <ButtonLoading
                label="Excluir"
                onClick={() => setOpenDelete(true)}
                isDelete
              />
            ) : null}
          </Row>
        </form>
        {openDelete && (
          <DialogConfirm onResponse={deleteItem} entity="esse projeto" />
        )}
      </DialogContent>
    </Dialog>
  );
}

const styles: { [key: string]: CSSProperties } = {
  container: {
    margin: "3%",
  },

  title: {
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "19px",
    lineHeight: "28px",
    letterSpacing: "0.4px",
    color: "#252733",
  },

  buttonContainer: {
    gap: 12,
    justifyContent: "flex-end",
    marginBottom: 20,
    paddingRight: 20,
  },
};

export default DialogTestCase;
